<ng-container *ngIf="dcpGlobalMessageService.getActiveMessages() | async as disposableMessages">
  <ng-container *ngIf="disposableMessages.length">
    <ng-content></ng-content>
    <ng-container *ngIf="filteredErrorMessages() |  async as filteredErrorMessages">
      <div class="disposable-message"
        [class.udex-mb-8]="(filteredWarningMessages() |  async).length || (filteredInfoMessages() |  async).length || (filteredConfirmationMessages() | async).length">
        <udex-message-strip
          *ngIf="filteredErrorMessages.length"
          class="body--s"
          design="Negative"
          status-type="Icon"
          (close)="removeMessages(filteredErrorMessages)"
        >
          <span *ngIf="convertMessagesToStrings(filteredErrorMessages).length === 1" [innerHtml]="convertMessagesToStrings(filteredErrorMessages)[0]">
          </span>
          <span *ngIf="convertMessagesToStrings(filteredErrorMessages).length > 1" [innerHtml]="convertMessagesToStrings(filteredErrorMessages)">
          </span>
          <ng-container *ngIf="filteredErrorMessages[0].showSupportLink"
            >&nbsp;<udex-link
              (click)="contactSupport(filteredErrorMessages[0].errorMessage, filteredErrorMessages[0].errorCode)"
              (keydown.enter)="contactSupport(filteredErrorMessages[0].errorMessage, filteredErrorMessages[0].errorCode)"
              data-cy="contact-support-link-single"
              class="text-capitalize"
              >{{'checkout.error.contactSupport' | cxTranslate}}
            </udex-link>
          </ng-container>
          <ng-container *ngIf="filteredErrorMessages[0].button?.isShown"
            >&nbsp;<udex-link (click)="filteredErrorMessages[0].button.action()"
            [attr.data-cy]="filteredErrorMessages[0].button.id"
          >{{filteredErrorMessages[0].button.buttonText | cxTranslate}}
          </udex-link>
          </ng-container>
        </udex-message-strip>
      </div>
    </ng-container>
    <ng-container *ngIf="filteredWarningMessages() |  async as filteredWarningMessages">
      <div class="disposable-message"
      [class.udex-mb-8]=" (filteredInfoMessages() |  async).length || (filteredConfirmationMessages() | async).length">
        <udex-message-strip
          *ngIf="filteredWarningMessages.length"
          class="body--s"
          (close)="removeMessages(filteredWarningMessages)"
          design="Warning"
          status-type="Icon"
        >
          <span *ngIf="convertMessagesToStrings(filteredWarningMessages).length === 1"
            [innerHTML]="convertMessagesToStrings(filteredWarningMessages)[0]">
          </span>
          <span *ngIf="convertMessagesToStrings(filteredWarningMessages).length > 1"
            [innerHTML]="convertMessagesToStrings(filteredWarningMessages)">
          </span>
        </udex-message-strip>
      </div>
    </ng-container>
    <ng-container *ngIf="filteredInfoMessages() |  async as filteredInfoMessages">
      <div class="disposable-message"
      [class.udex-mb-8]="(filteredConfirmationMessages() | async).length">
        <udex-message-strip
          *ngIf="filteredInfoMessages.length"
          class="body--s"
          (close)="removeMessages(filteredInfoMessages)"
          design="Information"
          status-type="Icon"
        >
          <span *ngIf="convertMessagesToStrings(filteredInfoMessages).length === 1"
            [innerHTML]="convertMessagesToStrings(filteredInfoMessages)[0]">
          </span>
          <span *ngIf="convertMessagesToStrings(filteredInfoMessages).length > 1"
            [innerHTML]="convertMessagesToStrings(filteredInfoMessages)">
          </span>
        </udex-message-strip>
      </div>
    </ng-container>
    <ng-container *ngIf="filteredConfirmationMessages() |  async as filteredConfirmationMessages">
      <!-- we want to show each confirmation message in its own box, treating the udex-message-strip component always as singleLine -->
      <div *ngFor="let message of filteredConfirmationMessages; index as i"
        class="disposable-message"
        [class.udex-mb-8]="filteredConfirmationMessages.length">
        <udex-message-strip
          class="body--s"
          [design]="message.group.startsWith('applied') ? 'Positive' : 'Information'"
          status-type="Icon"
          hide-close-button
        >
          <span
            [innerHTML]="convertMessagesToStrings(filteredConfirmationMessages)[i]">
          </span>
        </udex-message-strip>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="showActiveTemplate && dcpGlobalMessageService.getActiveTemplate() | async as disposableMessageTmpl"
>
  <ng-container *ngIf="disposableMessageTmpl">
    <div class="disposable-message">
      <ng-content></ng-content>
      <ng-container
        [ngTemplateOutlet]="disposableMessageTmpl"
      ></ng-container>
    </div>
  </ng-container>
</ng-container>
